import { o as V } from "./index-D_t0kTBY.js";
import { m as d, aq as q, u as m, a as L, q as Y, B as $, o as K, b as z, c as l, e as n, f as u, n as g, g as a, F as y, p as G, k as c, h as _, w as f, l as w, i as S } from "./define-element-XpjsV6s1.js";
import { u as Q, r as W, H as j } from "./use-cart-D8NOb7eE.js";
import { u as D } from "./use-product-y102e61c.js";
import { i as J } from "./utils-CMsllPx8.js";
import { f as X } from "./format-currency-D_QngrXg.js";
import { C as Z } from "./Cart-DB72546L.js";
import { B as U } from "./Button-D5lKR5Sd.js";
import { P as ee } from "./Prop65Warning-CQH0AdaD.js";
import { _ as te } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const oe = { class: "offset-side-cart-also-wrapper" }, se = { class: "offset-side-cart-also-product" }, ae = ["href"], le = ["src", "alt"], ne = ["innerHTML"];
var b, B, x, P;
const re = {
  __name: "SideCart",
  props: {
    showYouMayAlsoLike: {
      type: Boolean,
      default: !1
    },
    inheritStyle: {
      type: String,
      default: "all"
    },
    cartUrl: {
      type: String,
      default: (B = (b = window.OFFSET) == null ? void 0 : b.cartUrl) != null ? B : "/cart"
    },
    // Left unset by default so the type-aware getCheckoutUrl() fallback
    // applies — pass an explicit checkout-url attribute to override it.
    checkoutUrl: {
      type: String,
      default: ""
    },
    shopUrl: {
      type: String,
      default: (P = (x = window.OFFSET) == null ? void 0 : x.shopUrl) != null ? P : "/"
    }
  },
  setup(T) {
    const r = T, { isPending: E, data: F } = D(), { cart: p, addToCart: A } = Q(), h = d(() => {
      var t, e, o;
      return ((o = (e = (t = p.value) == null ? void 0 : t.items) == null ? void 0 : e.length) != null ? o : 0) > 0;
    }), v = d(() => r.checkoutUrl || q());
    function M(t) {
      let e = t.length;
      for (; e != 0; ) {
        let o = Math.floor(Math.random() * e);
        e--, [t[e], t[o]] = [
          t[o],
          t[e]
        ];
      }
    }
    const R = d(() => {
      const t = (F.value || []).filter((e) => !p.value.items.some((o) => o.sku === e.sku));
      return M(t), t;
    }), k = m("container"), I = m("alsoContainer"), H = m("closeButton"), s = L(!1);
    let i = null;
    function N(t) {
      window.location = t;
    }
    W(j.showSideCart, () => {
      s.value = !0;
    }), V(k, () => s.value = !1, {
      ignore: [I]
    });
    function C(t = 10) {
      const e = H.value;
      e && (e.focus(), e.getRootNode().activeElement !== e && t > 0 && requestAnimationFrame(() => C(t - 1)));
    }
    Y(s, (t) => {
      t ? (i = document.activeElement, $(() => C())) : i && typeof i.focus == "function" && i.focus();
    });
    function O(t) {
      t.key === "Escape" && s.value && (s.value = !1);
    }
    return K(() => {
      z(k.value, r.inheritStyle);
    }), (t, e) => (l(), n(y, null, [
      r.showYouMayAlsoLike && !u(E) ? (l(), n("div", {
        key: 0,
        class: g(["offset-side-cart-also", [s.value ? "visible" : ""]]),
        ref: "alsoContainer"
      }, [
        a("div", oe, [
          e[3] || (e[3] = a("h2", null, "You may also like", -1)),
          (l(!0), n(y, null, G(R.value, (o) => (l(), n("div", se, [
            u(J)(o.image) ? c("", !0) : (l(), n("a", {
              key: 0,
              href: "/product/detail/" + o.sku
            }, [
              a("figure", null, [
                a("img", {
                  src: o.image_small || o.image_medium || o.image,
                  alt: o.name,
                  loading: "lazy",
                  decoding: "async"
                }, null, 8, le)
              ])
            ], 8, ae)),
            a("h3", {
              class: "offset-product-title",
              innerHTML: o.name + " - " + u(X)(o.price)
            }, null, 8, ne),
            _(U, {
              "aria-label": `Add ${o.name} to cart`,
              onClick: (ie) => u(A)(o.sku, 1, { maxPurchaseQuantity: o.max_purchase_quantity })
            }, {
              default: f(() => e[2] || (e[2] = [
                S(" Add to Cart ", -1)
              ])),
              _: 2,
              __: [2]
            }, 1032, ["aria-label", "onClick"])
          ]))), 256))
        ])
      ], 2)) : c("", !0),
      a("div", {
        class: g(["offset-side-cart", [s.value ? "visible" : ""]]),
        ref: "container",
        role: "dialog",
        "aria-modal": "true",
        "aria-label": "Cart",
        onKeydown: O
      }, [
        _(Z, {
          checkoutUrl: v.value,
          shopUrl: r.shopUrl,
          showPromoCode: !1,
          hideActions: !0
        }, {
          header: f(() => [
            e[4] || (e[4] = a("h2", null, "Cart", -1)),
            a("button", {
              ref: "closeButton",
              onClick: e[0] || (e[0] = (o) => s.value = !1),
              "aria-label": "Close Cart",
              class: "offset-close"
            }, " x ", 512)
          ]),
          "footer-actions": f(() => [
            h.value ? (l(), w(U, {
              key: 0,
              onClick: e[1] || (e[1] = (o) => N(v.value)),
              class: "offset-side-cart-checkout"
            }, {
              default: f(() => e[5] || (e[5] = [
                S("Checkout", -1)
              ])),
              _: 1,
              __: [5]
            })) : c("", !0),
            h.value ? (l(), w(ee, {
              key: 1,
              class: "offset-side-cart-prop65"
            })) : c("", !0)
          ]),
          _: 1
        }, 8, ["checkoutUrl", "shopUrl"])
      ], 34)
    ], 64));
  }
}, ge = /* @__PURE__ */ te(re, [["__scopeId", "data-v-5be2e316"]]);
export {
  ge as S
};
